@if (!loader.isLoading()) {
  <form [formGroup]="form" (ngSubmit)="submit()">
    <div class="row g-3">
      <div class="col-6">
        <label for="name" class="form-label fw-bold small">Name</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-tag"></i></span>
          <input type="text" class="form-control" id="name" formControlName="name">
        </div>
      </div>
      <div class="col-6">
        <label for="subId" class="form-label fw-bold small">Sub ID</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-tag"></i></span>
          <input type="text" class="form-control" id="subId" formControlName="subId">
        </div>
      </div>
    </div>
    <div class="row g-3">
      <div class="col-6">
        <label for="goal" class="form-label fw-bold small">Goal</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-gift"></i></span>
          <select id="goal" class="form-control" formControlName="goalId">
            <option disabled>Goal</option>
            @for (goal of goals; track goal) {
              <option [value]="goal.id">{{ goal }}</option>
            }
          </select>
        </div>
      </div>
      <div class="col-3 pt-4">
        <app-input-switch formControlName="includePrivate">Send private goals</app-input-switch>
      </div>
      <div class="col-3 pt-4">
        <app-input-switch formControlName="enabled">Enabled</app-input-switch>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        @for (variable of variables; track variable) {
          <span (click)="insertVariable(variable)" class="badge bg-primary me-2"
          role="button">{{ variable }}</span>
        }
      </div>
    </div>
    <div class="row g-3">
      <div class="col-12">
        <label for="url" class="form-label fw-bold small">URL</label>
        <div class="input-group">
          <span class="input-group-text"><i class="bi bi-globe"></i></span>
          <input type="text" class="form-control" id="url" formControlName="url">
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-auto">
        <h3>Offers ({{ this.selectedOffers.length }})</h3>
      </div>
      <div class="col-auto">
        <select class="form-control" style="width: 200px;" [(ngModel)]="newOffer" [ngModelOptions]="{standalone: true}">
          @for (offer of getAvailableOffers(); track offer) {
            <option [ngValue]="offer">{{ offer }}</option>
          }
        </select>
      </div>
      <div class="col-auto">
        <button (click)="addOffer()" type="button" class="btn btn-primary fw-bold" [disabled]="!newOffer"><i
        class="bi bi-plus me-2"></i>Add
      </button>
    </div>
  </div>
  <div class="row">
    <div class="col">
      <table class="table mt-3">
        <thead>
          <tr>
            <th>Offer</th>
            <th class="text-end">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (selectedOffer of selectedOffers; track selectedOffer) {
            <tr>
              <td>{{ selectedOffer.name }}</td>
              <td class="text-end">
                <button (click)="removeOffer(selectedOffer)" type="button" class="btn btn-primary btn-sm fw-bold">Remove
                </button>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>
  </div>
  <div class="row mt-3">
    <div class="col-12 text-end">
      <button [disabled]="form.invalid" type="submit" class="btn btn-primary fw-bold">Update</button>
    </div>
  </div>
</form>
}
